<template>
  <div class="row">
    <div class="col-md-12 d-flex justify-content-between">
      <h1 class="h3 mb-3 text-gray-800">
        {{ $t("Relatórios de Famílias") }}
      </h1>

      <b-dropdown
        no-caret
        variant="primary"
        size="sm"
        v-b-tooltip.hover
        right
        title="Menu de Relatórios de Famílias"
      >
        <template #button-content>
          Menu
          <i class="fas fa-bars"></i>
        </template>
        <b-dropdown-group id="dropdown-group-1" header="Relatórios de Famílias">
          <b-dropdown-item
            :to="'/dashboard/relatorios/familias/home'"
            :disabled="$route.name == 'relatorios_home_familias'"
          >
            Todas as Famílias
          </b-dropdown-item>
          <b-dropdown-item
            :to="'/dashboard/relatorios/familias/graficos'"
            :disabled="$route.name == 'graficos_familias'"
          >
            Gráficos de Famílias
          </b-dropdown-item>
        </b-dropdown-group>
      </b-dropdown>
    </div>
    <!-- <div class="col-md-3 mb-4 p-0 shadow bg-white">
      <b-list-group>
        <b-list-group-item to="/dashboard/relatorios/familias/home">
          {{ $t("Gráficos") }}
        </b-list-group-item>
        <b-list-group-item to="/dashboard/relatorios/scfv/home">
          {{ $t("Filtro Personalizado") }}
        </b-list-group-item>
      </b-list-group>
    </div> -->
    <div class="col-md-12">
      <load v-if="loading" />
      <router-view v-else />
    </div>
  </div>
</template>
<script>
export default {
  name: "ReportsFamilia",
  metaInfo() {
    return {
      title: this.$i18n.t("Relatórios de Famílias"),
    };
  },
  mounted() {},
  data() {
    return {
      loading: false,
    };
  },
  methods: {},
};
</script>
